module.exports = __webpack_public_path__ + "img/1alB-k-kua.520f27c2.jpg";